import * as def from '@/definitions'
import { TextInfo } from '@/utilityModels/textInfo'
import { Layer } from './layer';
import { ArrayHelper } from '@/helper/arrayHelper';
import { StringHelper } from '@/helper/stringHelper';
import { ObjectLayer } from './objectLayer';
import { DateHelper } from '@/helper/dateHelper';

export class DateTextLayer extends ObjectLayer
{
    public get layerType() { return "dateText"; }

    // 文法情報
    private _textInfo = new TextInfo();
    public get textInfo() { return this._textInfo; }
    public set textInfo(textInfo) { this._textInfo = textInfo; }

    // 不透明度(%)
    private _opacity = 100;
    public get opacity() { return this._opacity; }
    public set opacity(opacity) { this._opacity = opacity; }

    // 設定日付
    private _dateData = new DateData();
    public get dateData() { return this._dateData; }
    public set dateData(dateData) { this._dateData = dateData; }

    // 区切り
    // 0: 年月日
    // 1: ドット
    // 2: スラッシュ
    // 3: ハイフン
    // 4: スペース
    private _splitType : number = 0
    public get splitType() { return this._splitType; }
    public set splitType(splitType) { this._splitType = splitType; }

    // 年
    // 0: なし
    // 1: 2018
    // 2: 18
    // 3: 平成30
    // 4: H30
    // 5: 30
    private _yearType : number = 1;
    public get yearType() { return this._yearType; }
    public set yearType(yearType) { this._yearType = yearType; }

    // 月
    // 0: なし
    // 1: 8
    // 2: August
    // 3: Aug
    private _monthType : number = 1;
    public get monthType() { return this._monthType; }
    public set monthType(monthType) { this._monthType = monthType; }
    
    // 日
    // 0: なし
    // 1: 7
    private _dayType : number = 1;
    public get dayType() { return this._dayType; }
    public set dayType(dayType) { this._dayType = dayType; }

    // 曜日
    // 0: なし
    // 1: TuesDay
    // 2: Tue
    // 3: (TuesDay)
    // 4: (Tue)
    // 5: 火
    // 6: 火曜
    // 7: 火曜日
    // 8: (火)
    // 9: (火曜)
    // 10: (火曜日)
    private _weekdayType : number = 0;
    public get weekdayType() { return this._weekdayType; }
    public set weekdayType(weekdayType) { this._weekdayType = weekdayType; }

    // 月日2桁
    private _is2Digits : boolean = false;
    public get is2Digits() { return this._is2Digits; }
    public set is2Digits(is2Digits) { this._is2Digits = is2Digits; }

    // 増減
    private _dateDelta : number = 0;
    public get dateDelta() { return this._dateDelta; }
    public set dateDelta(dateDelta) { this._dateDelta = dateDelta; }

    // 選択中の増減タイプ
    // 0: 年
    // 1: 月
    // 2: 日
    public _selectedDelta = 2;
    public get selectedDelta() { return this._selectedDelta; }
    public set selectedDelta(selectedDelta) { this._selectedDelta = selectedDelta; }

    // 自動(文字を枠に合わせたサイズにする)
    private _autoSize : boolean = false;
    public get autoSize() : boolean { return this._autoSize; }
    public set autoSize(autoSize : boolean) { this._autoSize = autoSize; }

    // 自動折り返し(ある程度で折り返す)
    private _autoNewLine : boolean = false;
    public get autoNewLine() : boolean { return this._autoNewLine; }
    public set autoNewLine(autoNewLine : boolean) { this._autoNewLine = autoNewLine; }

    // 行間(%)
    private _lineSpacing : number = 120;
    public get lineSpacing() : number { return this._lineSpacing; }
    public set lineSpacing(lineSpacing) { this._lineSpacing = lineSpacing; }
    
    // 文字方向
    // 0: 横書き
    // 1: 縦書き
    private _textOrientation : number = 0;
    public get textOrientation() : number { return this._textOrientation; }
    public set textOrientation(textOrientation : number ) { this._textOrientation = textOrientation; }

    // 水平揃え
    // 0: 左
    // 1: 中央
    // 2: 右
    // 3: 均等
    private _horizontalAlignment : number = 0;
    public get horizontalAlignment() : number { return this._horizontalAlignment; }
    public set horizontalAlignment(horizontalAlignment : number) { this._horizontalAlignment = horizontalAlignment; }

    // 垂直揃え
    // 0: 上
    // 1: 中央
    // 2: 下
    private _verticalAlignment : number = 0;
    public get verticalAlignment() : number { return this._verticalAlignment; }
    public set verticalAlignment(verticalAlignment : number) { this._verticalAlignment = verticalAlignment; }

    // 語頭追加
    private _prefix : string = "";
    public get prefix() : string { return this._prefix; }
    public set prefix(prefix : string) { this._prefix = prefix; }

    // 語尾追加
    private _suffix : string = "";
    public get suffix() : string { return this._suffix; }
    public set suffix(suffix : string) { this._suffix = suffix; }

    // 日付を今日に更新
    public updateDateDataToday()
    {
        var date = DateHelper.getDateToday();
        this.dateData.applyDate(date);
    }

    // 表示文字列を取得する
    public getText()
    {
        // 日付をずらす
        var dYear = this._selectedDelta == 0 ? this._dateDelta : 0;
        var dMonth = this._selectedDelta == 1 ? this._dateDelta : 0;
        var dDay = this._selectedDelta == 2 ? this._dateDelta : 0;
        var date = this._dateData.shift(dYear, dMonth, dDay);

        var str = "";

        // 語頭
        str += this._prefix;

        // 年
        var yearstr = date.getYearString(this._yearType);
        if(yearstr.length > 0)
        {
            str += yearstr;

            // 区切り
            if(this._splitType == 0) { str += "年"; }
            else if(this._splitType == 1) { str += "."; }
            else if(this._splitType == 2) { str += "/"; }
            else if(this._splitType == 3) { str += "-"; }
            else if(this._splitType == 4) { str += " "; }
        }

        // 月
        var monthstr = date.getMonthString(this._monthType, this._is2Digits);
        if(monthstr.length > 0)
        {
            str += monthstr;

            // 区切り
            if(this._splitType == 0) { str += "月"; }
            else if(this._splitType == 1) { str += "."; }
            else if(this._splitType == 2) { str += "/"; }
            else if(this._splitType == 3) { str += "-"; }
            else if(this._splitType == 4) { str += " "; }
        }

        // 日
        var daystr = date.getDayString(this._dayType, this._is2Digits);
        if(daystr.length > 0)
        {
            str += daystr;

            // 区切り
            if(this._splitType == 0) { str += "日"; }
        }

        // 曜日
        var weekdaystr = date.getWeekdayString(this._weekdayType);
        if(weekdaystr.length > 0)
        {
            str += weekdaystr;
        }

        // 語尾
        str += this._suffix;

        if(this._textInfo.isEmQuad)
        {
            // 全角が設定されている場合は、文字列を全角変換する
            str = StringHelper.toEmQuadString(str);
        }

        return str;
    }

    // 作成
    public static create(x : number, y : number, width : number, height : number) : DateTextLayer
    {
        var layer = new DateTextLayer();
        
        layer.autoSize = true;
        layer.autoNewLine = false;

        layer.horizontalAlignment = 0;
        layer.verticalAlignment = 0;
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;

        // 今日を設定
        layer.updateDateDataToday();
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new DateTextLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : DateTextLayer)
    {
        layer.textInfo = this._textInfo.clone();
        layer.opacity = this._opacity;
        layer.dateData = this._dateData.clone();
        layer.splitType = this._splitType;
        layer.yearType = this._yearType;
        layer.monthType = this._monthType;
        layer.dayType = this._dayType;
        layer.is2Digits = this._is2Digits;
        layer.weekdayType = this._weekdayType;
        layer.dateDelta = this._dateDelta;
        layer.selectedDelta = this._selectedDelta;
        layer.autoSize = this._autoSize;
        layer.autoNewLine = this._autoNewLine;
        layer.lineSpacing = this._lineSpacing;
        layer.textOrientation = this._textOrientation;
        layer.horizontalAlignment = this._horizontalAlignment;
        layer.verticalAlignment = this._verticalAlignment;
        layer.prefix = this._prefix;
        layer.suffix = this._suffix;
        
        super.cloneParameter(layer);
    }
    

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.textInfo = this._textInfo;
        jsonObject.opacity = this._opacity;
        jsonObject.dateData = this._dateData;
        jsonObject.splitType = this._splitType;
        jsonObject.yearType = this._yearType;
        jsonObject.monthType = this._monthType;
        jsonObject.dayType = this._dayType;
        jsonObject.is2Digits = this._is2Digits;
        jsonObject.weekdayType = this._weekdayType;
        jsonObject.dateDelta = this._dateDelta;
        jsonObject.selectedDelta = this._selectedDelta;
        jsonObject.autoSize = this._autoSize;
        jsonObject.autoNewLine = this._autoNewLine;
        jsonObject.lineSpacing = this._lineSpacing;
        jsonObject.textOrientation = this._textOrientation;
        jsonObject.horizontalAlignment = this._horizontalAlignment;
        jsonObject.verticalAlignment = this._verticalAlignment;
        jsonObject.prefix = this._prefix;
        jsonObject.suffix = this._suffix;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : DateTextLayer
    {
        var layer = new DateTextLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.textInfo != null) { this._textInfo = TextInfo.createFromJsonData(jsonData.textInfo); }
        if(jsonData.opacity != null) { this._opacity = jsonData.opacity; }
        if(jsonData.dateData != null) { this._dateData = DateData.createFromJsonData(jsonData.dateData); }
        if(jsonData.splitType != null) { this._splitType = jsonData.splitType; }
        if(jsonData.yearType != null) { this._yearType = jsonData.yearType; }
        if(jsonData.monthType != null) { this._monthType = jsonData.monthType; }
        if(jsonData.dayType != null) { this._dayType = jsonData.dayType; }
        if(jsonData.is2Digits != null) { this._is2Digits = jsonData.is2Digits; }
        if(jsonData.weekdayType != null) { this._weekdayType = jsonData.weekdayType; }
        if(jsonData.dateDelta != null) { this._dateDelta = jsonData.dateDelta; }
        if(jsonData.selectedDelta != null) { this._selectedDelta = jsonData.selectedDelta; }
        if(jsonData.autoSize != null) { this._autoSize = jsonData.autoSize; }
        if(jsonData.autoNewLine != null) { this._autoNewLine = jsonData.autoNewLine; }
        if(jsonData.lineSpacing != null) { this._lineSpacing = jsonData.lineSpacing; }
        if(jsonData.textOrientation != null) { this._textOrientation = jsonData.textOrientation; }
        if(jsonData.horizontalAlignment != null) { this._horizontalAlignment = jsonData.horizontalAlignment; }
        if(jsonData.verticalAlignment != null) { this._verticalAlignment = jsonData.verticalAlignment; }
        if(jsonData.prefix != null) { this._prefix = jsonData.prefix; }
        if(jsonData.suffix != null) { this._suffix = jsonData.suffix; }

        // 日付は常に最新にする
        this.updateDateDataToday();

        super.loadParameterFromJson(jsonData);
    }
}

// 日付クラス
export class DateData
{
    public year : number = 1900;
    public month : number = 1;
    public day : number = 1;

    // 指定だけずらしたものを得る
    public shift(dYear : number, dMonth : number, dDay : number)
    {
        var shiftedDate = DateHelper.shiftDate(this.year, this.month, this.day, dYear, dMonth, dDay);
        var dateData = new DateData(shiftedDate.getFullYear(), shiftedDate.getMonth() + 1, shiftedDate.getDate());
        return dateData;
    }

    // 各文字列表記を取得する
    // 0: なし
    // 1: 2018
    // 2: 18
    // 3: 平成30
    // 4: H30
    // 5: 30
    public getYearString(type)
    {
        return DateHelper.getYearString(type, this.year, this.month, this.day);
    }

    // 0: なし
    // 1: 8
    // 2: August
    // 3: Aug
    public getMonthString(type, is2Digits)
    {
        return DateHelper.getMonthString(type, is2Digits, this.month);
    }

    // 0: なし
    // 1: 7
    public getDayString(type, is2Digits)
    {
        return DateHelper.getDayString(type, is2Digits, this.day);
    }

    // 0: なし
    // 1: TuesDay
    // 2: Tue
    // 3: (TuesDay)
    // 4: (Tue)
    // 5: 火
    // 6: 火曜
    // 7: 火曜日
    // 8: (火)
    // 9: (火曜)
    // 10: (火曜日)
    public getWeekdayString(type)
    {
        var dayOfWeek = DateHelper.getDayOfWeek(this.year, this.month, this.day);
        return DateHelper.getWeekdayString(type, dayOfWeek);
    }

    constructor(year = 1900, month = 1, day = 1)
    {
        this.year = year;
        this.month = month;
        this.day = day;
    }

    public applyDate(date : Date)
    {
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;   // 月は 0 - 11 になっているので +1
        this.day = date.getDate();
    }

    public clone()
    {
        var cloned = new DateData();
        cloned.year = this.year;
        cloned.month = this.month;
        cloned.day = this.day;
        return cloned;
    }

    // JSON
    public toJSON()
    {
        var jsonObj = 
        {
            year : this.year,
            month : this.month,
            day : this.day
        };

        return jsonObj;
    }

    public static createFromJsonData(jsonData : any) : DateData
    {
        var data = new DateData();
        if(jsonData.year != null) { data.year = jsonData.year; }
        if(jsonData.month != null) { data.month = jsonData.month; }
        if(jsonData.day != null) { data.day = jsonData.day; }
        return data;
    }
}